import { render, staticRenderFns } from "./FaucetSection.vue?vue&type=template&id=22d8ecc9&"
import script from "./FaucetSection.vue?vue&type=script&lang=js&"
export * from "./FaucetSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports